module.exports = __webpack_public_path__ + "img/画板 2@3x.7c5142cb.png";